<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <!-- 统一60%居中nav容器，包含标题、正文、参考文献全部内容 -->
    <div class="nav">
      <!-- 模块标题 -->
      <div class="module-title">
        <h1>CT设备结构虚拟仿真系统</h1>
      </div>

      <!-- 主内容卡片 -->
      <div class="ct-content">
        <!-- 第一段文字 -->
        <p class="text-content">
          {{ p[0] }}
        </p>

        <!-- 图片网格 -->
        <div class="image-grid-section">
          <ImgCol :imgList="img.slice(2)" />
        </div>

        <!-- 第二段文字 -->
        <p class="text-content">
          {{ p[1] }}
        </p>

        <!-- 底部大图 -->
        <div class="ct-image-wrapper">
          <div class="image-container">
            <img
              :src="wWidth < 768 ? img[1] : img[0]"
              alt="CT设备结构三维仿真模型，CT机房扫描间虚拟展示"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>

      <!-- 引用组件，置于nav内部 -->
      <div class="refer-margin">
        <Refer />
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue";
import Refer from "@/components/products/sameRefer.vue";
import PullDown from "@/components/home/pullDown.vue"

export default {
   props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "DeviceCT",
  components: {
    ImgCol,
    Refer,
    PullDown,
  },
  data() {
    return {
      p: [
        "CT设备精密昂贵、内部结构难以直观展示，传统教学依赖图纸和理论讲解，学生理解困难。本系统构建CT设备仿真模型和虚拟场景（含操作间、扫描间），对CT设备结构和主要元件实现1:1仿真再现，进行细节认知和模拟拆装。可实现对场景布局、设备结构、各组件细节和技术参数的深度认知和学习，并能够进行场地规划、机房设计、设备安装与调试以及设备使用等交互操作，将理论知识与临床实践紧密结合。以《医学影像设备学》为理论支撑，将抽象的设备结构知识转化为沉浸式三维认知体验，大幅降低学习门槛。",
      ],
      img: [
        require("@/assets/dCT_last.png"),
        require("@/assets/phone/dctGrid.png"),
        require("@/assets/dCT1.png"),
        require("@/assets/dCT2.png"),
        require("@/assets/dCT3.png"),
        require("@/assets/dCT4.png"),
        require("@/assets/dCT5.png"),
        require("@/assets/dCT6.png"),
      ],
      wWidth: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  // 核心居中容器
  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }

    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  // 标题美化
  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    .title-icon {
      font-size: 2rem;
      @media (max-width: 767px) {
        font-size: 1.5rem;
      }
    }

    .title-badge {
      font-size: 0.7rem;
      font-weight: 600;
      color: #fff;
      background: linear-gradient(135deg, #2563eb, #3b82f6);
      padding: 0.2rem 0.8rem;
      border-radius: 20px;
      letter-spacing: 0.06em;
      box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);

      @media (max-width: 767px) {
        font-size: 0.6rem;
        padding: 0.15rem 0.6rem;
      }
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  // 主内容卡片
  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
    }

    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
    }

    // 文字样式
    .text-content {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 0.95rem;
      line-height: 2;
      color: #1e293b;
      text-align: justify;
      letter-spacing: 0.01em;
      position: relative;
      padding-left: 1rem;
      border-left: 3px solid transparent;

      @media (max-width: 767px) {
        font-size: 0.85rem;
        line-height: 1.85;
        padding-left: 0.75rem;
      }

      &:first-of-type {
        margin-bottom: 2rem;
        border-left-color: #3b82f6;
        background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
        padding: 0.75rem 1rem 0.75rem 1.5rem;
        border-radius: 0 8px 8px 0;

        @media (max-width: 767px) {
          padding: 0.5rem 0.75rem 0.5rem 1rem;
        }
      }

      &:last-of-type {
        margin-bottom: 2rem;
        border-left-color: #3b82f6;
        background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
        padding: 0.75rem 1rem 0.75rem 1.5rem;
        border-radius: 0 8px 8px 0;

        @media (max-width: 767px) {
          padding: 0.5rem 0.75rem 0.5rem 1rem;
        }
      }
    }

    // 图片网格区域
    .image-grid-section {
      margin: 2rem 0 2.5rem;
      border-radius: 12px;
      overflow: hidden;
      background: #fafcff;
      padding: 0.5rem;

      ::v-deep .img-col {
        .grid-item {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);

          &:hover {
            box-shadow: 0 8px 30px rgba(37, 75, 156, 0.12);
            transform: translateY(-4px) scale(1.01);
          }

          img {
            transition: transform 0.5s ease;
          }

          &:hover img {
            transform: scale(1.05);
          }
        }
      }
    }

    // 底部大图容器
    .ct-image-wrapper {
      max-width: 847px;
      margin: 0 auto;
      border-radius: 16px;
      overflow: hidden;
      background: #f8faff;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

      @media (max-width: 767px) {
        max-width: 100%;
        border-radius: 12px;
      }

      .image-container {
        position: relative;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          height: auto;
          transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 1.5rem 2rem;
          background: linear-gradient(0deg, rgba(0,0,0,0.6) 0%, transparent 100%);
          opacity: 0;
          transition: opacity 0.4s ease;

          @media (max-width: 767px) {
            padding: 1rem 1.25rem;
          }

          .overlay-text {
            color: #ffffff;
            font-size: 0.9rem;
            font-weight: 500;
            letter-spacing: 0.06em;
            @media (max-width: 767px) {
              font-size: 0.75rem;
            }
          }
        }

        &:hover {
          img {
            transform: scale(1.03);
          }

          .image-overlay {
            opacity: 1;
          }
        }
      }
    }
  }

  // 参考文献间距
  .refer-margin {
    margin-top: 2rem;
    padding: 0 2rem 2rem;

    @media (max-width: 767px) {
      margin-top: 1.5rem;
      padding: 0 1rem 1.5rem;
    }
  }
}

// 暗色模式支持
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);

        .title-badge {
          background: linear-gradient(135deg, #1d4ed8, #3b82f6);
        }

        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .text-content {
          color: #c8d6e8;

          &:first-of-type {
            border-left-color: #3b82f6;
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }

          &:last-of-type {
            border-left-color: #8b5cf6;
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }

        .image-grid-section {
          background: #0d1627;

          ::v-deep .img-col .grid-item {
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);

            &:hover {
              box-shadow: 0 8px 30px rgba(37, 75, 156, 0.2);
            }
          }
        }

        .ct-image-wrapper {
          background: #0d1627;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        }
      }
    }
  }
}

:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}

</style>